import m from "mithril";

import { rootPath } from "../lib/routes";

type LayoutParams = {
  children: any[];
};

export class Layout {
  view(vnode: LayoutParams) {
    return(
      <>
        <nav>
          <div class="content">
            <a class="logo" href={ rootPath() }>
              <h1>Advent Calendar</h1>
            </a>
          </div>
        </nav>

        <ul class="lightrope">
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
        </ul>
        <div class="stars" />

        <div class="content body">
          {vnode.children}
        </div>
      </>
    );
  }
}
